import type { RouteObject } from 'react-router';

/**
 * `/settings`. One lazy chunk holding one screen, the shape `review.routes.tsx` and
 * `archive.routes.tsx` use.
 *
 * Deliberately no navigation blocker: FR-018 discards unsaved edits on navigation without
 * prompting. Five numbers retyped cost less than a dialogue on every exit, and
 * `settings-page.spec.tsx` asserts this array stays free of one. Angular spelled that as the absence
 * of a `canDeactivate` guard; React Router's counterpart is a `<Blocker>`/`useBlocker` in the page or
 * a `shouldRevalidate`-style hook on the route, so the spec asserts the absence of BOTH a route-level
 * blocker key and any `useBlocker` in the page source.
 */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./settings-page')).default }) },
];
